import { SuppliersProvider } from 'Context/SuppliersContext';
import { SuppliersMain } from './SuppliersMain';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { Helmet } from 'react-helmet-async';

export const Suppliers = () => {
  return (
    <SuppliersProvider>
      <Helmet title={Dictionary[DICTIONARY.Suppliers].title} />
      <SuppliersMain />
    </SuppliersProvider>
  );
};
